import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import {PassageiroApiService} from "../shared/passageiro-api.service";
import {passageirosQuery, passageirosModuleName} from "../shared/data.service";
import {PassageiroService} from "../shared/passageiro.service";
import {UtilService} from "../../../shared/services/util.service";
import {PassageiroDeslocamento} from "../shared/passageiro.model";

@Component({
    selector: 'app-passageiro-deslocamento-form-list',
    template: require('./passageiro-deslocamento-form-list.component.html'),
    styles: [require('./passageiro-deslocamento-form-list.component.css')]
})
export class PassageiroDeslocamentoFormListComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() pontosList: any[] = [];
    @Input() deslocamentoId: number;
    @Input() isAdm: boolean = false;
    @Input() isEdition: boolean = false;

    moduleName: any = passageirosModuleName;
    passageiroObject: any = {};
    newObject: any = {};
    passageiroQuery: any;
    submitted: boolean = false;
    passageiroId: string = 'passageiroSelect';

    form2: FormGroup;
    passageiro = new FormControl('', Validators.required);
    observacao = new FormControl('');
    acompanhante = new FormControl('');

    constructor(
        private _passageiroApiService: PassageiroApiService,
        private _passageiroService: PassageiroService,
        private _autocompleteService: AutoCompleteService,
        private _utilService: UtilService,

        private _fb: FormBuilder
    ) {
        this.form2 = _fb.group({
            passageiro: this.passageiro,
            observacao: this.observacao,
            acompanhante: this.acompanhante
        });
    }

    ngOnInit() {
        this.passageiroQuery = this._utilService.cloneObject(passageirosQuery);
        this.newItem();

        this.formatPassageiros();
    }

    clickRemove(item: any, index: number) {
        let onDelete = (function() {
            if (this.list[index].id) {
                this.onRemovePassageiro(item.id);
            } else {
                this.list.splice(index, 1);
            }
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    changePassageiroPonto(passageiro: any) {
        if (passageiro.id) {
            let pontoId: number;
            if (passageiro.pontoEmbarque) {
                pontoId = passageiro.pontoEmbarque.id;
            }
            let object: any = {pontoDeslocamentoEmbarqueId: pontoId, id: passageiro.id};
            this.onEditPassageiro(object);
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            let object: any = this._utilService.cloneObject(this.newObject);

            if (this.isAdm || this.isEdition) {
                object.passageiroId = this.passageiroObject.id;
                object.deslocamentoId = this.deslocamentoId;

                this.onAddPassageiro(object);
            } else {
                object.passageiro = this.passageiroObject;
                this.setNewList(object);
            }
        }
    }

    getPassageiroObject(object: any) {
        this.passageiroObject = object;
        this._utilService.setSelectOnFormControl(this.form2, 'passageiro', object);
    }

    passageiroTemplateResult = (function(state: any) {
        return this._passageiroService.templateResult(state, false);
    }.bind(this));

    private newItem() {
        this.newObject = {
            acompanhante: false,
            observacao: '',
            ativo: true
        };
    }

    private setNewList(object: any) {
        this.list.push(object);

        this.newItem();
        this.passageiroObject = {};
        this._autocompleteService.setValueOnSelect2(null, this.passageiroId);
        this._utilService.setSelectOnFormControl(this.form2, 'passageiro', {});

        this.submitted = false;
    }

    private formatPassageiros() {
        let x: number, lenX: number,
            y: number, lenY: number,
            ponto: any;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
            for (y = 0, lenY = this.pontosList.length; y < lenY; y++) {
                ponto = this.pontosList[y];
                if (this.list[x].pontoDeslocamentoEmbarqueId === this.pontosList[y].id) {
                    this.list[x].pontoEmbarque = this.pontosList[y];
                    break;
                }
            }
        }
    }

    private onAddPassageiro(object: PassageiroDeslocamento) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                Response.passageiro = this.passageiroObject;
                this.setNewList(Response);

                this._utilService.swalMessageAddSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._passageiroApiService.onPostPassageiroDeslocamento(object, onDone);
    }

    private onEditPassageiro(object: PassageiroDeslocamento) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === object.id) {
                        this.list[x].pontoDeslocamentoEmbarqueId = object.pontoDeslocamentoEmbarqueId;
                        break;
                    }
                }

                this._utilService.swalMessageAddSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._passageiroApiService.onPutPassageiroDeslocamento(object, onDone);
    }

    private onRemovePassageiro(objectId: number) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === objectId) {
                        this.list[x].ativo = false;
                        break;
                    }
                }

                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._passageiroApiService.onDeletePassageiroDeslocamento(objectId, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiro-deslocamento-form-list/passageiro-deslocamento-form-list.component.ts
 **/